<template>
    <div class="col-sm-6 col-md-3 col-lg-2 d-flex align-items-end">
        <div class="form-group w-100">
            <label for="perPage" v-text="translations.itemsPerPage"></label>
            <select id="perPage" name="perPage" class="form-control" v-model="currentSelection" v-on:change="paginate">
                <option v-for="index in this.perPageCount" :key="index" :value="index" v-text="index"></option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: ['perPage', 'translations'],

    data() {
        return {
            perPageCount: [10, 20, 30, 40, 50],
            currentSelection: this.perPage
        };
    },

    methods: {
        paginate() {
            this.$emit('onFilter', {
                data: { perPage: this.currentSelection }
            });
        }
    }
};
</script>
